import CryptoJS from "crypto-js";

export const encryptWithAES = (data) => {
  try {
    const secretKey = process.env.REACT_APP_AES_ENCRYPTION_SECRET_KEY;
    if (!secretKey) return false;

    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
    return encrypted;
  }
  catch {
    return false;
  }
};

export const decryptWithAES = (encrypted) => {
  try {
    const secretKey = process.env.REACT_APP_AES_ENCRYPTION_SECRET_KEY;
    if (!secretKey) return false;
    
    const bytes = CryptoJS.AES.decrypt(encrypted, secretKey);
    const decrypted = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decrypted;
  }
  catch {
    return false;
  }
};